<template>
  <div>
    <p class="text-center mt-3" v-if="visita.peneiras.length == 0">
      <i>Nenhuma pesagem realizada</i>
    </p>
    <v-expansion-panels flat multiple v-else class="mt-1">
      <v-expansion-panel
        class="white"
        v-for="(pesagem, i) in visita.peneiras"
        :key="i"
      >
        <v-expansion-panel-header class="font-weight-bold pl-0 pt-0 pb-0">
          <v-list-item dense>
            <v-list-item-avatar
              ><v-btn
                icon
                color="error"
                @click.stop="removerPesagem(i)"
                title="Remover pesagem"
                ><v-icon>mdi-delete-outline</v-icon></v-btn
              ></v-list-item-avatar
            >
            <v-list-item-title class="subtitle-2 font-weight-bold">{{
              pesagem.tipo
            }}</v-list-item-title>
          </v-list-item>
        </v-expansion-panel-header>
        <v-divider></v-divider>
        <v-expansion-panel-content>
          <v-data-table
            class="mt-3"
            :items="tabelaRefPesagem(pesagem)"
            no-data-text="Nenhuma pesagem localizada"
            hide-default-footer
            :headers="headers"
            disable-sort
            dense
          >
            <template v-slot:[`item.peneira`]="{ item }">
              <span class="font-weight-medium indigo--text">{{
                item.peneira
              }}</span>
            </template>
            <template v-slot:[`item.peso`]="{ item }">
              <span>{{ item.peso.toFixed(2) }}</span>
            </template>
            <template v-slot:[`item.perc_result`]="{ item }">
              <span>{{ item.perc_result }}%</span>
            </template>
          </v-data-table>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: mapState("visitaTecnica", ["configuracoes", "visita"]),
  data: () => ({
    headers: [
      { text: "Peneira", value: "peneira" },
      { text: "Peso(g)", value: "peso" },
      { text: "%Result", value: "perc_result" },
      { text: "%Ref", value: "ref" },
    ],
    desc_peneiras: ["Superior", "Média", "Inferior"],
  }),
  methods: {
    removerPesagem(pos) {
      this.visita.peneiras.splice(pos, 1);
    },
    tabelaRefPesagem(pesagemSelec) {
      var cfg_mat_pes = this.configuracoes.dados.materiais_pesagem.find(
        (mp) => mp.tipo.toLowerCase() == pesagemSelec.tipo.toLowerCase()
      );

      var { pesoSelec, percSelec } = 0.0;
      var { peneiraSelec, refSelec } = "";

      var tabelaPennState = [];
      for (let index = 0; index < 3; index++) {
        if (index == 0) {
          peneiraSelec = "Superior";
          pesoSelec = pesagemSelec.peneira_superior;
          percSelec = pesagemSelec.perc_pen_superior;
          refSelec = cfg_mat_pes.ref_pen_sup;
        } else if (index == 1) {
          peneiraSelec = "Média";
          pesoSelec = pesagemSelec.peneira_media;
          percSelec = pesagemSelec.perc_pen_media;
          refSelec = cfg_mat_pes.ref_pen_med;
        } else if (index == 2) {
          peneiraSelec = "Inferior";
          pesoSelec = pesagemSelec.peneira_inferior;
          percSelec = pesagemSelec.perc_pen_inferior;
          refSelec = cfg_mat_pes.ref_pen_inf;
        }

        tabelaPennState.push({
          peneira: peneiraSelec,
          peso: pesoSelec,
          perc_result: percSelec,
          ref: refSelec,
        });
      }

      return tabelaPennState;
    },
  },
};
</script>

<style>
</style>